import React from 'react';
import PropTypes from 'prop-types';
//import { Map } from 'immutable';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import normalizeWheel from 'normalize-wheel';

import { limitTransform } from 'helpers/photo';

import { setDraggingPreview } from 'redux/reducers/app';
import { pickMoment, updateTransform } from 'redux/reducers/orders';
import { updatePreview } from 'redux/reducers/photos';

import { getActiveOrderId } from 'redux/selectors/app';
import { getSpreadDimensions } from 'redux/selectors/design';

import { MomentEdit, MomentWarning, Photo } from 'components';

import cx from 'classnames';
import styles from './styles.scss';

const MENU_WIDTH = 40;

@connect(
  (state, props) => ({
    orderId: getActiveOrderId(state),
    spreadDimensions: getSpreadDimensions(state),
    draggingPhoto: state.getIn(['app', 'isDragging'], false),
    draggingPreview: state.getIn(['app', 'draggingPreview'], null),
  }),
  {
    pickMoment,
    setDraggingPreview,
    updateTransform,
    updatePreview,
  }
)
export default class MomentPhoto extends React.PureComponent {
  static contextTypes = {
    orderId: PropTypes.string,
    bookId: PropTypes.number,
  };

  componentDidMount() {
    const { preview, orderId, momentId } = this.props;

    if (!preview || preview.isEmpty()) {
      this.props.updatePreview(orderId, momentId);
    }
  }

  componentWillUpdate(nextProps) {
    const { transform, orderId, momentId, updatePreview, photo } = this.props;
    const { transform: newTransform, photo: newPhoto } = nextProps;

    if (
      (photo === null && newPhoto) ||
      (photo && newPhoto && photo.get('simpleId') !== newPhoto.get('simpleId')) ||
      (transform && newTransform && transform.rotate !== newTransform.rotate)
    ) {
      updatePreview(orderId, momentId);
    }
  }

  onMouseEnter = () => {
    const { momentId, draggingPhoto } = this.props;

    if (draggingPhoto) {
      this.props.setDraggingPreview(momentId);
    }
  };

  onMouseLeave = () => {
    const { draggingPhoto } = this.props;

    if (draggingPhoto) {
      this.props.setDraggingPreview(null);
    }
  };

  onMouseUp = () => {
    const { orderId, momentId, draggingPhoto } = this.props;

    if (draggingPhoto) {
      this.props.pickMoment(orderId, momentId, draggingPhoto.get('simpleId'));
    }
  };

  render() {
    const {
      scale,
      design,
      photo,
      backAndWhite,
      transform,
      style,
      preview,
      spreadDimensions,
      draggingPreview,
      draggingPhoto,
      orderId,
      momentId,
      momentWidth,
      momentHeight,
      updateTransform,
      rotate,
    } = this.props;
    const { bookId } = this.context;

    let placeholder = null;
    const placeholderImage = design.getIn(['options', 'placeholder_image', 'url'], null);
    if (placeholderImage) {
      placeholder = (
        <div
          className={styles.placeholder}
          style={{
            ...style,
            backgroundImage: 'url(' + placeholderImage + ')',
          }}
        />
      );
    }

    const classes = cx(styles.moment, {
      [styles.blackwhite]: backAndWhite,
    });

    // const leftAlignedMenu = ((design.get('x') * scale) + momentWidth + MENU_WIDTH) > (spreadDimensions.get('width') * scale);
    const leftAlignedMenu = design.get('x') >= spreadDimensions.get('width') / 2;

    let content;
    if (momentId === draggingPreview) {
      const t = { width: 1, x: 0, y: 0 };
      const limitedTransform = limitTransform(draggingPhoto.get('exif'), t, scale, momentWidth, momentHeight);

      content = (
        <DraggablePhoto
          key="preview"
          imageClassName={styles.photo}
          scale={scale}
          photo={draggingPhoto}
          transform={limitedTransform}
          style={style}
          orderId={orderId}
          momentId={momentId}
          momentWidth={momentWidth}
          momentHeight={momentHeight}
          updateTransform={updateTransform}
        />
      );
    } else if (photo) {
      content = (
        <span>
          <DraggablePhoto
            key="draggable"
            imageClassName={styles.photo}
            scale={scale}
            photo={photo}
            preview={preview}
            transform={transform}
            style={style}
            orderId={orderId}
            momentId={momentId}
            momentWidth={momentWidth}
            momentHeight={momentHeight}
            updateTransform={updateTransform}
          />
          <MomentEdit
            key="edit"
            className={styles.editMenu}
            orderId={orderId}
            momentId={momentId}
            //align={'left'}
            align={leftAlignedMenu ? 'left' : 'right'}
            photo={photo}
            transform={transform}
            updateTransform={updateTransform}
          />
          {transform.lowDpi ? (
            <MomentWarning rotate={rotate}>
              {kroostApp.strings.warningToAdjustPhotoPart1}
              <br />
              <a
                href={`https://kroost.${global.kroostApp.domainExtension}/designer-low-dpi`}
                target="_blank">
                {kroostApp.strings.warningToAdjustPhotoPart2}
              </a>
            </MomentWarning>
          ) : null}
        </span>
      );
    } else {
      content = (
        <span>
          <Link to={`/${bookId}/${orderId}/assignment`}>{placeholder}</Link>
        </span>
      );
    }

    return (
      <div
        className={classes}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onMouseUp={this.onMouseUp}>
        {content}
      </div>
    );
  }
}

class DraggablePhoto extends React.PureComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      isDragging: false,
      dimensions: [0, 0],
      start: [0, 0],
      dragged: [0, 0],
    };
  }

  componentWillMount() {
    const { preview } = this.props;
    if (preview && !preview.isEmpty()) {
      this.updateTransform();
    }
  }

  componentDidUpdate(prevProps) {
    const { preview } = this.props;
    const { preview: prevPreview } = prevProps;

    if (!(prevPreview && !prevPreview.isEmpty()) && preview && !preview.isEmpty()) {
      this.updateTransform();
    }
  }

  onWheel = e => {
    const normalized = normalizeWheel(e);
    const delta = normalized.pixelX || normalized.pixelY;

    const multiplier = delta > 0 ? -1 : 1;
    const deltaDiff = Math.min(Math.abs(delta), 400);
    const zoom = (0.1 + 0.3 * (deltaDiff / 400)) * multiplier;

    this.updateTransform(null, zoom);
  };

  onMouseDown = e => {
    e.preventDefault();

    this.setState({
      isDragging: true,
      dimensions: [e.target.clientWidth, e.target.clientHeight],
      draggedTransform: {},
      start: [e.clientX, e.clientY],
    });
  };

  onMouseMove = e => {
    e.preventDefault();
    const [x, y] = this.state.start;

    const { photo, transform, preview, scale, momentWidth, momentHeight } = this.props;
    const limitedTransform = limitTransform(
      {
        ...photo.get('exif'),
        ...(preview && preview.toJS ? preview.toJS() : {}),
      },
      transform,
      scale,
      momentWidth,
      momentHeight,
      [e.clientX - x, e.clientY - y]
    );

    this.setState({
      draggedTransform: limitedTransform,
    });
  };

  onMouseUp = e => {
    e.preventDefault();

    const [startX, startY] = this.state.start;
    this.updateTransform([e.clientX - startX, e.clientY - startY]);

    this.setState({
      isDragging: false,
    });
  };

  updateTransform = (...args) => {
    const { orderId, photo, preview, transform, momentId, scale, momentWidth, momentHeight } = this.props;

    const limitedTransform = limitTransform(
      {
        ...photo.get('exif'),
        ...(preview ? preview.toJS() : {}),
      },
      transform,
      scale,
      momentWidth,
      momentHeight,
      ...args
    );

    this.props.updateTransform(orderId, momentId, limitedTransform);
  };

  render() {
    const { isDragging, draggedTransform } = this.state;
    const { transform, style = {}, preview, scale, momentWidth, momentHeight, ...props } = this.props;

    let offsetTransform = transform;
    if (isDragging) {
      offsetTransform = {
        ...transform,
        ...draggedTransform,
      };
    }

    return (
      <div
        className={styles.draggablePhoto}
        style={style}
        onWheel={this.onWheel}
        onMouseDown={!isDragging ? this.onMouseDown : null}
        onMouseMove={isDragging ? this.onMouseMove : null}
        onMouseUp={isDragging ? this.onMouseUp : null}
        onMouseOut={isDragging ? this.onMouseUp : null}>
        <Photo
          transform={offsetTransform}
          preview={preview ? preview.get('preview') : null}
          fullPhoto={true}
          {...props}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/moment-photo/index.js